export default __webpack_public_path__ + "static/media/duitnow4.19f75307.png";